import {Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2} from '@angular/core';
import * as loadImage from 'blueimp-load-image';
import {From} from '../../shared/models/chat.model';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MessageComponent implements OnInit {
  @Input() public from: string;
  @Input() public warning: boolean;
  @Input() public file: File;
  @Input() public edition: boolean;
  @Input() public body: string;
  @Input() public breakStrong: boolean;
  @Output() public edit: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('imageElement') imageElement: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.file?.type?.includes('image/')) {
      loadImage(this.file,
        img => this.renderer.appendChild(this.imageElement.nativeElement, img),
        {
          maxWidth: 1200,
          orientation: true,
          meta: true
        }
      );
    }
  }

  public get fromUser(): boolean {
    return this.from === From.user;
  }
}
